export default "__VITE_ASSET__aoxOp0pD__ 584w";